// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"community_productcontent__XWzcD"};